import {
  type FC,
  type PropsWithChildren,
  useEffect,
  useRef,
  useState,
} from 'react';

import { checkIfClaimDateIsToday } from '@/common/lib/checkIfClaimDateIsToday';
import { addFullscreenModal } from '@/redux/reducers/modalsReducer';
import { useAppDispatch } from '@/redux/store';

import { CompleteContractAnimation } from './CompleteContractAnimation';
import { CompleteContractAnimationContext } from './context';

const CompleteContractAnimationProvider: FC<PropsWithChildren> = ({
  children,
}) => {
  const dispatch = useAppDispatch();
  const [isAnimationStart, setIsAnimationStart] = useState(false);
  const [animationStep, setAnimationStep] = useState<1 | 2 | 3>(1);
  const [reward, setReward] = useState<{
    cash: number;
    point: number;
    dice?: number;
    silverTicket?: number;
    goldTicket?: number;
    diamondTicket?: number;
  }>({ cash: 0, point: 0, dice: 0 });
  const [contractId, setContractId] = useState<string | null>(null);
  const contractListWrapperRef = useRef<HTMLDivElement | null>(null);
  const lastCompleteContractHasProductOfDayRef = useRef<boolean>(false);
  const timerId = useRef<NodeJS.Timeout>();

  useEffect(() => {
    const productOfDayOffersIsVisitedToday = checkIfClaimDateIsToday(
      'productOfDayOffersLastTimeVisit',
    );

    if (
      isAnimationStart &&
      lastCompleteContractHasProductOfDayRef.current &&
      !productOfDayOffersIsVisitedToday
    ) {
      timerId.current = setTimeout(() => {
        dispatch(addFullscreenModal({ name: 'productOfDayOffers', props: {} }));
        lastCompleteContractHasProductOfDayRef.current = false;
      }, 1500);
    }
  }, [isAnimationStart]);

  useEffect(() => {
    return (): void => {
      clearTimeout(timerId.current);
    };
  }, []);

  return (
    <CompleteContractAnimationContext.Provider
      value={{
        isAnimationStart,
        setIsAnimationStart,
        reward,
        setReward,
        animationStep,
        setAnimationStep,
        contractId,
        setContractId,
        contractListWrapperRef,
        lastCompleteContractHasProductOfDayRef,
      }}
    >
      <CompleteContractAnimation {...reward} />
      {children}
    </CompleteContractAnimationContext.Provider>
  );
};

export { CompleteContractAnimationProvider };
